import { render, staticRenderFns } from "./publisher-info.html?vue&type=template&id=ad65c9cc&scoped=true&external"
import script from "./publisher-info.js?vue&type=script&lang=js&external"
export * from "./publisher-info.js?vue&type=script&lang=js&external"
import style0 from "./publisher-info.scss?vue&type=style&index=0&id=ad65c9cc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad65c9cc",
  null
  
)

export default component.exports